export default "__VITE_ASSET__9c13d173__"